import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import InputField from '../../../../FormComponents/InputField/InputField'
import CheckboxesList from '../../../../FormComponents/CheckboxesList/CheckboxesList'
import UserExpandedBlock from './UserExpandedBlock'
import { checkValueInStore } from '../../../../AdditionalReportFilters/helpers'
import { clientConstants } from '../../../constants'
import { screenSize, page as pageIndex } from '../../../../../globals'
import { updateExpandedSection } from '../../../helpers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faPen, faSave } from '@fortawesome/free-solid-svg-icons'

class ClientUserRow extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      expanded: false,
      currentRow: undefined,
      contacts: [],
      hidden: false,
      startNum: 10,
      allowEditing: {
        edit: false,
        rowId: ''
      }
    }
    this.handleScroll = this.handleScroll.bind(this)
    this.expandSection = this.expandSection.bind(this)
    this.showDelete = this.showDelete.bind(this)
  }

  componentDidMount () {
    this.setState({ contacts: this.props.contacts, hidden: true })
    this.timerID = setInterval(() => this.changeState(), 100)
  }

  changeState = () => {
    this.setState({ hidden: false })
  }

  componentWillUnmount () {
    clearInterval(this.timerID)
  }

  expandSection = (event) => {
    const { field, contacts, updatePermissions, page, sendData } = this.props
    const { currentRow, expanded } = this.state
    const expandedValue = event.target.getAttribute('data-info') !== currentRow ||
      (event.target.getAttribute('data-info') === currentRow && !expanded)
    const currentValue = event.target.getAttribute('data-info')
    const prevValue = currentRow === undefined ? currentValue : currentRow
    this.setState({
      expanded: expandedValue,
      prevSelected: prevValue,
      currentRow: currentValue
    })
    if (field === 'clientUsers' && expandedValue) {
      const itemData = contacts.filter(el => el.UserId === parseInt(currentValue))
      updatePermissions(currentValue, itemData)
    }
    updateExpandedSection(field.includes('Users'), expandedValue, currentValue, prevValue)
    if (page !== pageIndex.cmd) {
      sendData(currentValue)
    }
  }

  showDelete = (id) => () => {
    const { sendData, showModal } = this.props
    sendData(id)
    showModal(`Delete-user-${id}`)
  }

  allowEditing = (id) => () => {
    this.setState({
      allowEditing: {
        edit: this.state.rowId !== id ? true : !this.state.allowEditing.edit,
        rowId: id
      }
    })
  }

  updateUserData = (id) => () => {
    this.setState({
      allowEditing: {
        edit: false,
        rowId: id
      }
    })
  }

  returnRowFields = (editOpt, field, itemData, isEdited) => {
    const { trackData, updateData } = this.props
    return clientConstants.inputsList[field].map((elem, i) => {
      switch (elem.type) {
        case 'input':
          const elemName = elem.name === 'UserName' ? itemData.FirstName + itemData.LastName : itemData[elem.name]
          const check = elem.name === 'UserEmail' && field === 'dashboardUsers'
          const className = check ? 'client-user-col with-bin' : 'client-user-col border'
          const allowEditingClass = editOpt.edit && editOpt.rowId === itemData.UserId &&
            elem.name !== 'LogonId' ? ' allow-editing' : ''
          return <div className={className + allowEditingClass} key={i}>
            {window.innerWidth <= screenSize.extraSmall ? <div className="modal-titles">{elem.title}</div> : null}
            <InputField
              type="text"
              location={{ id: itemData.UserId, field }}
              id={elem.name}
              value={checkValueInStore(elem.name, elemName, trackData[itemData.UserId])}
              updateData={updateData}
            />
            {check
              ? <Fragment>
                {editOpt.edit && editOpt.rowId === itemData.UserId
                  ? <FontAwesomeIcon
                    className="dashboard-bin"
                    icon={faSave}
                    alt="save icon"
                    onClick={this.updateUserData(itemData.UserId)}
                  />
                  : <FontAwesomeIcon
                    className="dashboard-bin"
                    icon={faPen}
                    alt="edit icon"
                    onClick={this.allowEditing(itemData.UserId)}
                  />
                }
                <FontAwesomeIcon
                  className="dashboard-bin"
                  icon={faTrash}
                  alt="delete icon"
                  onClick={this.showDelete(itemData.UserId)}
                />
              </Fragment>
              : null}
          </div>
        case 'checkbox':
          return <div className="client-user-col with-cb" key={i}>
            <CheckboxesList
              location={{ id: itemData.UserId, field }}
              fieldData={[{
                id: elem.name,
                text: window.innerWidth <= screenSize.extraSmall ? elem.title : '',
                type: 'checkbox'
              }]}
              values={trackData[itemData.UserId]}
              updateData={updateData}
              isEdited={isEdited}
            />
          </div>
      }
    })
  }

  returnRowItem = (num) => {
    const { contacts, editItem } = this.props
    let resultedArray = []
    if (editItem) {
      resultedArray.push(this.returnItem(editItem, editItem.UserId))
    } else {
      const length = contacts.length > 10 ? num : contacts.length
      for (let i = 0; i <= length - 1; i++) {
        resultedArray.push(this.returnItem(contacts[i], i))
      }
    }
    return resultedArray
  }

  returnItem = (itemData, i) => {
    const { trackData, field, page, updateData, modal, isEdited } = this.props
    const { currentRow, expanded, allowEditing } = this.state
    const button = expanded && parseInt(currentRow) === itemData.UserId ? '-' : '+'
    const editingClass = allowEditing && allowEditing.edit && allowEditing.rowId === itemData.UserId
      ? ' allow-editing' : ''
    return <Fragment key={i}>
      <div className="row-item">
        {!modal
          ? <div
            className={expanded && parseInt(currentRow) === itemData.UserId
              ? 'plus-button transformed' : 'plus-button'}
            onClick={this.expandSection}
            data-info={itemData.UserId}
          >{page === pageIndex.dashboard ? ' ' : button}</div>
          : null}
        {this.returnRowFields(allowEditing, field, itemData, isEdited)}
      </div>
      <UserExpandedBlock
        key={'user' + i}
        itemData={itemData}
        field={field}
        trackData={trackData}
        updateData={updateData}
        updateExpandedSection={updateExpandedSection}
        expandSection={this.expandSection}
        modal={modal}
        isEdited={isEdited}
        permissionEditing={editingClass}
      />
    </Fragment>
  }

  handleScroll = (event) => {
    if (event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight) {
      const elementsList = document.querySelectorAll('.contact-rows .row-item')
      let nextItem = elementsList.length
      const data = this.props.contacts
      if (elementsList.length <= data.length - 5) {
        this.setState({
          startNum: nextItem + 5
        })
      } else if (elementsList.length > data.length - 5 && elementsList.length < data.length) {
        this.setState({
          startNum: nextItem + (data.length - elementsList.length)
        })
      }
    }
  }

  render () {
    const { contacts } = this.props
    if (!contacts) {
      return null
    } else {
      const { startNum, hidden } = this.state
      return <div className="contact-rows" onScroll={this.handleScroll}>
        {hidden ? null : this.returnRowItem(startNum)}
      </div>
    }
  }

  static propTypes = {
    page: PropTypes.string,
    field: PropTypes.string,
    contacts: PropTypes.array,
    trackData: PropTypes.object,
    updateData: PropTypes.func,
    modal: PropTypes.bool,
    updatePermissions: PropTypes.func,
    editItem: PropTypes.object,
    sendData: PropTypes.func,
    isEdited: PropTypes.bool,
    showModal: PropTypes.func
  }
}

export default ClientUserRow



// WEBPACK FOOTER //
// ./src/components/ClientContacts/components/ClientUsers/components/ClientUserRow.js